// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"styles_Navbar__20BMz","active":"styles_active__HHa4i"};